import React, { Component } from 'react'
import { connect } from 'react-redux'

import DeliveryTrackingItem from './DeliveryTrackingItem'
import * as actions from 'actions/index'
import './DeliveryTracking.scss'

class DeliveryTracking extends Component {

  componentDidMount() {
    this.props.onGetOrders()
    this.props.onChangeTitleHeader('Delivery Tracking')
  }

  render() {
    return (
      <div className="main-content">
        <div className="list-items tracking">
          {
            this.props.orders.length > 0 ?
              this.props.orders.map((order, index) => (
                <DeliveryTrackingItem order={order} key={index} />
              )) :
              <div className="delivery-tracking-no-items"><h1>There is no order to Track Today</h1></div>
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    orders: state.deliveryTrackingReducer.orders
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onChangeTitleHeader: titleHeader => dispatch(actions.changeMenuTitleHeader(titleHeader)),
    onGetOrders: () => dispatch(actions.getOrders())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryTracking)



// WEBPACK FOOTER //
// ./src/containers/DeliveryTracking/index.js